import { render, staticRenderFns } from "./Firma.vue?vue&type=template&id=3404c78e"
import script from "./Firma.vue?vue&type=script&lang=js"
export * from "./Firma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports